import { React, useEffect ,useState} from "react";
import CustomInput from "../../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import { v4 as uuidv4 } from 'uuid';
import {
  createNewNewsCat,
  getANewsCatt,
  resetState,
  updateANewsCat,
} from "../features/CountrySclice";

let schema = yup.object().shape({
  id: yup.string(),
  countryName: yup.string().required("Country is Required"),
  description: yup.string().required("Description is Required"),
  link: yup.string().required("Link is Required"),
  type: yup.string().required("Type is Required"),
});

const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsCatId = location.pathname.split("/")[3];
  const newNewsCategory = useSelector((state) => state.country);
  const [uuid, setUuid] = useState(uuidv4());
  const {
    isSuccess,
    isError,
    isLoading,
    createNewsCategory,
    countryName,
    description,
    link,
    type,
    updatedNewsCategory,
  } = newNewsCategory;

  useEffect(() => {
    if (getNewsCatId !== undefined) {
      dispatch(getANewsCatt(getNewsCatId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsCatId]);

  useEffect(() => {
    if (isSuccess && (createNewsCategory || updatedNewsCategory)) {
      const successMessage = getNewsCatId !== undefined ? "Updated" : "Added";
      toast.success(`Country  ${successMessage} Successfully!`);
      navigate("/admin/Country-List");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      hexCode: "#ff9d96",
      order: 0,
      id: getNewsCatId || uuid,
      countryName: countryName || "",
      description: description || "",
      link: link || "",
      type: type || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getNewsCatId !== undefined) {
        dispatch(updateANewsCat({ id: getNewsCatId, NewsCatData: values }));
      } else {
        dispatch(createNewNewsCat(values));
        formik.resetForm();
      }
      dispatch(resetState());
    },
  });

  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} Country 
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="id"
            onChng={formik.handleChange("id")}
            onBlr={formik.handleBlur("id")}
            val={formik.values.id}
            label="ID"
            id="id"
            disabled={getNewsCatId !== undefined}
          />
          <CustomInput
            type="text"
            name="countryName"
            onChng={formik.handleChange("countryName")}
            onBlr={formik.handleBlur("countryName")}
            val={formik.values.countryName}
            label="Enter Country Name"
            id="countryName"
          />
          <div className="error">
            {formik.touched.countryName && formik.errors.countryName}
          </div>

          <CustomInput
            type="text"
            name="description"
            onChng={formik.handleChange("description")}
            onBlr={formik.handleBlur("description")}
            val={formik.values.description}
            label="Enter Description"
            id="description"
          />
          <div className="error">
            {formik.touched.description && formik.errors.description}
          </div>

          <CustomInput
            type="text"
            name="link"
            onChng={formik.handleChange("link")}
            onBlr={formik.handleBlur("link")}
            val={formik.values.link}
            label="Enter Image Link"
            id="link"
          />
          <div className="error">
            {formik.touched.link && formik.errors.link}
          </div>

          <CustomInput
            type="text"
            name="type"
            onChng={formik.handleChange("type")}
            onBlr={formik.handleBlur("type")}
            val={formik.values.type}
            label="Enter Type"
            id="type"
          />
          <div className="error">
            {formik.touched.type && formik.errors.type}
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading} 
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            { isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"}  Country
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
